import { Center, Spinner, Text } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

interface LoadingProps extends PropsWithChildren {
    w?: string;
    h?: string;
    spinnerSize?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const Loading = ({ w, h, spinnerSize = "xs", children }: LoadingProps) => {
    return (
        <Center w={w} h={h} flexDir="column" rowGap="20px">
            <Spinner size={spinnerSize} />
            <Text>{children}</Text>
        </Center>
    );
};
